/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconArrowDownward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconArrowDownward"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="m11 16.586-3.293-3.293-1.414 1.414L12 20.414l5.707-5.707-1.414-1.414L13 16.586V4h-2z"
    />
  </svg>
);
export default IconArrowDownward;
